import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"
import SideBar from "./Sidebar"
import FacetTabs from "./FacetTabs"
import { useEffect, useRef, useState } from "preact/hooks"

export function ToggleMobileSidebarButton({
    selectedFiltersCount,
    className,
    name,
    toggledFacet,
    setToggledFacet,
    idOfFacet,
    role,
    ariaSelected,
    tabIndex,
    id,
    ariaControls
}) {
    function getIdAndSetToggledFacet(e) {
        // console.log(e.target);
            const clickedFacetId = e.target.getAttribute('id');
            // console.log(clickedFacetId);
            setToggledFacet(idOfFacet);
    }
    const isMobile = window.innerWidth < 768;

    // const [isVisible, setIsVisible] = useState(true);

    // useEffect(() => {
    //     const handleScroll = () => {
    //     const productGrid = document.querySelector(".ns-serp");
    //     if (!productGrid) return;

    //     const gridTop = productGrid.getBoundingClientRect().top;
    //     const gridBottom = productGrid.getBoundingClientRect().bottom;
    //     const windowHeight = window.innerHeight;

    //     setIsVisible(gridTop < 0 && gridBottom > windowHeight);
    //     };

    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, []);

    return (
        <button
            type="button"
            // ref={buttonRef}
            // ns-d-md-none
            // ${isVisible ? 'visible-button' : 'hidden-button'}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className}`}
            // ${isMobile && 'ns-filters-mobile'} ${isMobile && isVisible ? 'ns-visible' : isMobile && !isVisible ? 'ns-hidden' : ''}
            // id={idOfFacet}
            // onClick={getIdAndSetToggledFacet}
            role={role}
            aria-selected={ariaSelected}
            tabIndex={tabIndex}
            id={id}
            aria-controls={ariaControls}
            onClick={()=>{
                const sidebarToggle = document.getElementById(toggleButtonId);
                if (sidebarToggle) {
                    sidebarToggle.click();
                }
                setTimeout(() => {
                    const startElement = document.getElementById('nosto-facets-container');
                    if (startElement) {
                    startElement.focus();
                    }
                }, 500);
            }}
        >
            {/* <Icon name="filter" /> */}
            {!isMobile ? (
                <span id={idOfFacet} tabIndex="0" onClick={getIdAndSetToggledFacet}>{name}</span>
            ) : (
                <span>FILTER / SORT</span>
            )}
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
            {!isMobile && (<span class="inline-block ml-1.5">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Plus" aria-hidden="true" class="w-2.5 h-2.5">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.375 6.90625L1.625 6.90625L1.625 6.09375L11.375 6.09375L11.375 6.90625Z" fill="currentColor"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.09375 11.375L6.09375 1.625L6.90625 1.625L6.90625 11.375L6.09375 11.375Z" fill="currentColor"></path>
                </svg>
            </span>)}
        </button>
    )
}

export default function Toolbar({isMobile}) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const [toggledFacet, setToggledFacet] = useState(null)

    const isCategoryPage = pageType === "category";

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `${docCount} results for "${query.query}"`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
        // ns-flex-md-row ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2 style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
            class="ns-header-controls ns-d-flex ns-flex-column ns-d-none ns-d-md-flex ns-flex-wrap align-center ns-justify-content-between"
        >
            {/* !loading &&  */}
            {!isCategoryPage ? (
                // <span
                //     class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                //     data-nosto-element="totalResults"
                // >
                //     {totalSummary}
                // </span>
                <div class="text-center p-8 border-t md:border-t-0">
                    <h1
                        class="h5"
                        data-nosto-element="totalResults"
                    >
                        {totalSummary}
                    </h1>
                </div>
            ) : ''}
            {/* ns-flex-wrap  ns-d-md-block ns-mb-4 */}
            <div class="ns-d-flex ns-justify-content-between nos-w-100 ns-sidebar-sort-container 
            md:px-10">
                {/* <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                /> */}
                {isMobile ? (
                    <ToggleMobileSidebarButton
                        selectedFiltersCount={selectedFiltersCount}
                    />
                ) : (
                    <FacetTabs toggledFacet={toggledFacet} setToggledFacet={setToggledFacet} numberOfProducts = {docCount}/>
                )}
                <SideBar toggledFacet={toggledFacet} setToggledFacet={setToggledFacet}/> 
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                /> */}
            </div>
        </div>
    )
}
